// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd9d85ba","455":"94348496","977":"4393dd5c"}[chunkId] + ".chunk.js";
};